"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cases = [[0, 1, 0, -1], [1, 1, 1, -1], [-1, 1, -1, -1], [1, 0, -1, 0], [1, 1, -1, 1], [1, -1, -1, -1]];
exports.distortedWarning = (imageDimensions, containerDimensions) => {
    if (imageDimensions === undefined ||
        !containerDimensions.widthValue ||
        !containerDimensions.heightValue ||
        containerDimensions.heightFormat !== 'px' ||
        containerDimensions.widthFormat !== 'px') {
        return false;
    }
    const imageDimensionsRatio = imageDimensions.width / imageDimensions.height;
    const containerWidth = containerDimensions.widthValue;
    const containerHeight = containerDimensions.heightValue;
    const hasBetween = cases.some(([width1, height1, width2, height2]) => {
        const containerDimensionsRatio1 = (containerWidth + width1) / (containerHeight + height1);
        const containerDimensionsRatio2 = (containerWidth + width2) / (containerHeight + height2);
        return imageDimensionsRatio >= containerDimensionsRatio1 && imageDimensionsRatio <= containerDimensionsRatio2;
    });
    return !hasBetween;
};
exports.upscaledWarning = (imageDimensions, containerDimensions) => {
    if (imageDimensions === undefined)
        return false;
    const containerHasPxHeight = containerDimensions.heightFormat === 'px' && !!containerDimensions.heightValue;
    const containerHasPxWidth = containerDimensions.widthFormat === 'px' && !!containerDimensions.widthValue;
    return ((containerHasPxHeight && imageDimensions.height < containerDimensions.heightValue) ||
        (containerHasPxWidth && imageDimensions.width < containerDimensions.widthValue));
};
//# sourceMappingURL=calculate-warnings.js.map